module.exports = __webpack_public_path__ + "static/media/mercurio_error_505.31ab1c53.svg";